import type { ApolloError } from '@apollo/client'
import { GetRoleSalaryRangesDocument, GetRoleSalaryRangesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type SalaryRange = NonNullable<
  GetRoleSalaryRangesQuery['jobCatalog']['role']
>['levels'][0]['salaryRanges'][0]

type Return = [SalaryRange[] | undefined, boolean, () => void, ApolloError | undefined]

export const useRoleSalaryRanges = (id: number): Return => {
  const { data, loading, refetch, error } = useQuery(GetRoleSalaryRangesDocument, {
    variables: { id },
  })

  const salaryRanges = data?.jobCatalog.role?.levels?.reduce<SalaryRange[]>((acc, x) => {
    return [...acc, ...x.salaryRanges] as SalaryRange[]
  }, [])

  return [!loading ? salaryRanges : undefined, loading, refetch, error]
}
